import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EmpoweringYourNextBigLeap from "./sections/EmpoweringYourNextBigLeap";
import TheVensigMandate from "./sections/TheVensigMandate";
import BrandedBasecamp from "./sections/BrandedBasecamp";
import OperatorLedConsulting from "./sections/OperatorLedConsulting";
import TimelessAesthetics from "./sections/TimelessAesthetics";
import GlobalImpactBenchmarks from "./sections/GlobalImpactBenchmarks";
import ReadyToScreenWithConfidence from "./sections/ReadyToScreenWithConfidence";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EmpoweringYourNextBigLeap />
      <TheVensigMandate />
      <BrandedBasecamp />
      <OperatorLedConsulting />
      <TimelessAesthetics />
      <GlobalImpactBenchmarks />
      <ReadyToScreenWithConfidence />
      <Footer />
    </div>;
}